var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgNewExclam1(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 175 175",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M93.269 80.844a6.219 6.219 0 00-12.438 0v37.312a6.22 6.22 0 006.22 6.219 6.22 6.22 0 006.218-6.219V80.844zm3.11-24.875a9.322 9.322 0 11-15.916-6.587 9.315 9.315 0 0113.174 0 9.327 9.327 0 012.741 6.587zM87.061 0a87.063 87.063 0 100 174.125A87.063 87.063 0 0087.063 0zM12.439 87.063a74.625 74.625 0 11149.249 0 74.625 74.625 0 01-149.25 0z",
    fill: "#000"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewExclam1);
export default ForwardRef;